import { MatchmakingMatchTypes } from '@colonist/game-base-types';
import { SocketMatchmakingSend } from '../../../shared/scripts/socket/SocketMatchmakingSend.ts';
import { createSpanIn, setElementInnerHTML, setElementInnerText, setElementOnClick } from '../../../shared/scripts/ui_utils/DomUtils.ts';
import { getNestedTranslation } from '@colonist/i18n';
import { isRankedMatchType } from '../../../shared/scripts/matchmaking/MatchmakingUtilsClient.ts';
export class UIMatchmakingSearchMatchPopupView {
    update(matchmakingStatusUpdate, primaryMatchType) {
        if (!this.isShowing()) {
            const gameModeText = UIMatchmakingSearchMatchPopupView.getGameModeText(primaryMatchType);
            const popupTitle = getNestedTranslation({
                key: 'strings:homePage.matchmakingPopup.searchingForGame'
            }, {
                gameMode: gameModeText
            });
            setElementInnerText(this.title, popupTitle);
            this.show();
        }
        const context = isRankedMatchType(primaryMatchType) ? 'ranked' : 'shuffle';
        setElementInnerHTML(this.text, {
            key: 'strings:homePage.matchmakingSearch.lookingForPlayers',
            options: {
                context: context
            }
        });
        if (matchmakingStatusUpdate.totalNumberOfPlayersNeeded != undefined) createSpanIn(this.text, '', {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: ` (${matchmakingStatusUpdate.numberOfPlayersFound}/${matchmakingStatusUpdate.totalNumberOfPlayersNeeded})`
            }
        });
    }
    setCancelAction() {
        setElementOnClick(this.cancelButton, ()=>{
            SocketMatchmakingSend.sendCancelFindGame();
            this.hide();
        });
    }
    isShowing() {
        return this.container.style.display == 'block';
    }
    hide() {
        this.container.style.display = 'none';
    }
    show() {
        this.container.style.display = 'block';
    }
    static getGameModeText(matchType) {
        switch(matchType){
            case MatchmakingMatchTypes.RankedCitiesAndKnights4P:
                return {
                    key: 'strings:homePage.matchmakingPopup.rankedCitiesAndKnights.title'
                };
            case MatchmakingMatchTypes.RankedClassic1v1:
                return {
                    key: 'strings:homePage.matchmakingPopup.ranked1v1.title'
                };
            case MatchmakingMatchTypes.RankedClassic4P:
                return {
                    key: 'strings:homePage.matchmakingPopup.ranked4Player.title'
                };
            case MatchmakingMatchTypes.UnrankedClassic1v1:
                return {
                    key: 'strings:homePage.matchmakingPopup.unranked1v1.title'
                };
            case MatchmakingMatchTypes.UnrankedClassic4P:
                return {
                    key: 'strings:homePage.matchmakingPopup.unranked4Player.title'
                };
            case MatchmakingMatchTypes.RankedRush4P:
                return {
                    key: 'strings:homePage.matchmakingPopup.rankedRush.title'
                };
            case MatchmakingMatchTypes.UnrankedShuffle:
                return {
                    key: 'strings:homePage.matchmakingPopup.shuffle.title'
                };
            default:
                return {
                    key: 'strings:colonistCommon.utils.emptyString'
                };
        }
    }
    constructor(){
        this.container = document.getElementById('matchmaking-searchmatch-popup');
        this.title = document.getElementById('matchmaking-searchmatch-title');
        this.text = document.getElementById('matchmaking_searchmatch_text');
        this.cancelButton = document.getElementById('matchmaking_searchmatch_cancelbutton');
        this.setCancelAction();
    }
}
